






import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';

import SystemStatsStore from '@/store/system/SystemStats.store';

import GaugeChart from '@/components/Utils/Charts/GaugeChart.vue';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {GaugeChart},
})
export default class SystemStatsCpuUsage extends Mixins<BaseComponent>(BaseComponent) {

  private statsStore: SystemStatsStore = getModule(SystemStatsStore, this.$store);

  get cpuLoad(): number {
    if (!this.statsStore.Stats) {
      return 0;
    }

    return (this.statsStore.Stats.System.CPULoads[0] < 1 ? this.statsStore.Stats.System.CPULoads[0] : 1) * 100;
  }
}
